import Swiper from 'swiper';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';

class VideoCarousel extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const slides = this.querySelectorAll('.swiper-slide');
    const hasMultipleSlides = slides.length > 1;

    const swiperConfig = {
      // Optional parameters
      slidesPerView: 1,
      modules: [Pagination, Navigation, Autoplay],
      loop: hasMultipleSlides, // Only loop if multiple slides
      pagination: {
        el: this.querySelector('.hero-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-video-next',
        prevEl: '.swiper-video-prev',
      },
    };

    // Only enable autoplay if there are multiple slides
    // For single slide, videos will autoplay via HTML autoplay attribute
    if (hasMultipleSlides) {
      swiperConfig.autoplay = {
        delay: 5000,
        disableOnInteraction: false,
      };
    }

    const swiper = new Swiper(this, swiperConfig);

    // Ensure videos autoplay when there's only one slide
    if (!hasMultipleSlides) {
      const videos = this.querySelectorAll('video');
      videos.forEach((video) => {
        // Ensure autoplay is set
        video.setAttribute('autoplay', '');
        // Play the video programmatically
        video.play().catch((err) => {
          console.log('Video autoplay prevented:', err);
        });
      });
    }

    const lazyLoadInstance = new LazyLoad({
      elements_selector: '.lazy',
      // ... more custom settings?
    });

    if (lazyLoadInstance) {
      lazyLoadInstance.update();
    }
  }
}
customElements.define('video-carousel', VideoCarousel);
